<p>
  responsive-component works!
</p>
